import { render } from "./TabsIndicator.vue?vue&type=template&id=07ec2162"
import script from "./TabsIndicator.vue?vue&type=script&lang=js"
export * from "./TabsIndicator.vue?vue&type=script&lang=js"

import "./TabsIndicator.vue?vue&type=style&index=0&id=07ec2162&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/components/TabsIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07ec2162"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07ec2162', __exports__)) {
    api.reload('07ec2162', __exports__)
  }
  
  module.hot.accept("./TabsIndicator.vue?vue&type=template&id=07ec2162", () => {
    api.rerender('07ec2162', render)
  })

}


export default __exports__